import { Form, Modal, Select } from "antd";
import React, { useState } from "react";
import { ESPTypeOptions } from "../../../constants/common";

interface ModalChangeWorkflowProps {
  open: boolean;
  onCancel?: () => void;
  onChange?: (espType: string, isForce?: boolean) => Promise<void> | void;
  espIds: React.Key[];
}

const ModalChangeWorkflow: React.FC<ModalChangeWorkflowProps> = ({ open, onCancel, onChange, espIds }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleOk = async (isForce = false) => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      if (!values.espType) {
        setLoading(false);
        return;
      }
      await onChange?.(values.espType, isForce);
    } catch (err) {
      // Validation error, do nothing
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel?.();
  };

  return (
    <Modal
      open={open}
      title="Changing Workflow"
      okText="Proceed Change"
      onCancel={handleCancel}
      onOk={() => handleOk(false)}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <p>Please select new Workflow to move these {espIds.length} ESPs</p>
        <Form.Item name="espType" label="" rules={[{ required: true, message: "Please select ESP Type" }]}>
          <Select
            placeholder="Select ESP Type"
            options={ESPTypeOptions}
            allowClear
            showSearch
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalChangeWorkflow;
